(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-funcion', {
            parent: 'entity',
            url: '/ss-funcion',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSFuncions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-funcion/s-s-funcions.html',
                    controller: 'SSFuncionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('ss-funcion-detail', {
            parent: 'ss-funcion',
            url: '/ss-funcion/{id}',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS'],
                pageTitle: 'SSFuncion'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-funcion/ss-funcion-detail.html',
                    controller: 'SSFuncionDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSFuncion', function($stateParams, SSFuncion) {
                    return SSFuncion.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ss-funcion',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ss-funcion-detail.edit', {
            parent: 'ss-funcion-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-funcion/ss-funcion-dialog.html',
                    controller: 'SSFuncionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSFuncion', function(SSFuncion) {
                            return SSFuncion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-funcion.new', {
            parent: 'ss-funcion',
            url: '/new',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-funcion/ss-funcion-dialog.html',
                    controller: 'SSFuncionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nombre: null,
                                descripcion: null,
                                altaReg: null,
                                bajaReg: null,
                                ultActReg: null,
                                activo: null,
                                usuarioUltAct: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ss-funcion', null, { reload: 'ss-funcion' });
                }, function() {
                    $state.go('ss-funcion');
                });
            }]
        })
        .state('ss-funcion.edit', {
            parent: 'ss-funcion',
            url: '/{id}/edit',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-funcion/ss-funcion-dialog.html',
                    controller: 'SSFuncionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SSFuncion', function(SSFuncion) {
                            return SSFuncion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-funcion', null, { reload: 'ss-funcion' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ss-funcion.delete', {
            parent: 'ss-funcion',
            url: '/{id}/delete',
            data: {
                authorities: ['ADMINISTRADOR_DE_PROGRAMA_SS']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/s-s-funcion/ss-funcion-delete-dialog.html',
                    controller: 'SSFuncionDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SSFuncion', function(SSFuncion) {
                            return SSFuncion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ss-funcion', null, { reload: 'ss-funcion' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
